import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { tampleteCopyRoute } from '@features/enterprise/api/constants';
import { errorMessage } from '@features/profile';
import axiosInstance from '@server/axiosInstance';
import { templateList } from '../constants';

type useCopyTemplateProps = {
    setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useCopyTemplate = ({
    setErrorText = () => { },
}: useCopyTemplateProps) => {
    const client = useQueryClient();

    const { mutate: copyTemplate, isLoading: isCopingTemplate } =
        useMutation({
            mutationFn: (variables: {
                template_id: string | number
                name: string
                description: string
            }) =>
                axiosInstance
                    .post(tampleteCopyRoute, variables)
                    .then((res) => res.data),
            onSuccess: (data) => {
                if (data.status !== 200) {
                    setErrorText(data.message);
                } else {
                    setErrorText('');
                    client.invalidateQueries([templateList]);
                }
            },
            onError: () => setErrorText(errorMessage),
        });

    return {
        copyTemplate,
        isCopingTemplate,
    };
};
